<template>
  <div>
      <div class="list" v-if="result && result?.games">
        <div class="game" :key="game.url" v-for="game in result.games">
          <img :src="$store.state.baseUrl+game.image.url" alt="">
          <div class="dev" v-if="game.inProgress">In development</div>
          <div class="title">{{game.title}}</div>
          <div class="desc">{{ game.description }}</div>
          <div class="more" v-if="game.url"><a target="_blank" :href="game.url">See more</a></div>
        </div>
      </div>    
      <div v-else-if="!result&&!loading">
        <h3>Something went wrong</h3>
        <p>Something bad has happened, most likely on our side. We're teribly sorry and are probably looking into it just now.</p>
      </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { useQuery } from '@vue/apollo-composable'
const GAMES_LIST = gql`
query {
  games {
    url
    title
    description
    inProgress
    image {
      url
    }
  }
}
`;
export default {
  name: 'GamesList',
  setup() {
    const { result, loading } = useQuery(GAMES_LIST)
    return {result, loading};
  },
  mounted() {
  },
  props: {
    //msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use "@/style.scss" as *;
.list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 30px;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  .game {
    padding: 30px;
    border: $secondary 3px solid;
    transition: border-color ease .25s;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    position: relative;
    height: 500px;
    img {
      width: 250px;
      border-radius: 5px;
    }
    .dev {
      font-family: jersey;
      position: absolute;
      font-size: 28px;
      text-align: center;
      color: $text;
      top: 125px;
      left: 50%; 
      width: max-content;
      transform: translateX(-50%);
      padding: 10px 20px;

      border: solid 1px #666;
      border-radius: 5px;
      background-color: rgba($secondary, .9);
      backdrop-filter: blur(3px);
      color: $accent;
    }
    .title {
      font-family: jersey;
      text-align: center;
      font-size: 28px;
      max-width: 250px;
      color: $primary;
    }
    .desc {
      max-width: 250px;
    }
    .more {
      position: absolute;
      right: 30px;
      bottom: 30px;
      text-align: right;
    }
  }
  .game:hover {
    border-color:$primary;
  }
}

</style>
